import React, { useState } from 'react';
import PropTypes from 'prop-types';

export const FollowUpFillInQuestion = ({ question, disabled, onAnswerChange }) => {
  const rdn = Math.random();
  const [value, setValue] = useState(question.answer.value);
  const [checked, setChecked] = useState(question.answer.checked);

  return (
    <div className="o-follow-up-question">
      <div className="o-follow-up-question__checkbox">
        <input
          id={`input-${rdn}`}
          className="o-follow-up-question__checkbox"
          type="checkbox"
          disabled={disabled}
          checked={checked}
          onChange={() => {
            setChecked(!checked);
            question.answer.checked = !checked;
            if (onAnswerChange) onAnswerChange();
          }}
        />
      </div>

      <div className="o-follow-up-question__label">
        <label htmlFor={`input-${rdn}`}>{question.title}</label>
      </div>

      <div className="o-follow-up-question__field">
        <input
          type="text"
          disabled={disabled || !checked}
          value={value}
          onChange={(event) => {
            setValue(event.target.value);
            question.answer.value = event.target.value;
            if (onAnswerChange) onAnswerChange();
          }}
        />
      </div>
    </div>
  )
}

FollowUpFillInQuestion.propTypes = {
  question: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired,
  onAnswerChange: PropTypes.func,
}
